import { get } from 'lodash';
import validation from '../../../scripts/services/validation';
import { addressChanged } from '../address/address.events';

class PersonTypes {
  static LEGAL = new PersonTypes('legal', "Юр. лицо")
  static NATURAL = new PersonTypes('natural', "Физ. лицо")
  constructor(value, text) {
    Object.assign(this, { value, text })
  }
}
const minlength = 'Минимальное количество символов – 2';
const validatorNames = 'Только буквы кириллицы и дефис';

export default [
  '$rootScope', 'addFormService', 'deviceService',
  function getAdditionalBenefits($rootScope, addFormService, deviceService) {
    this.isMobile = deviceService.isMobile;

    const checkCplFieldsAreEnabled = () => {
      return get(addFormService, 'ad.geo.jk.cplEnabled', false);
    };

    const refreshFieldsState = () => {
      this.fieldsIsRequired = checkCplFieldsAreEnabled();
      this.canShowButton = !this.fieldsIsRequired;
      this.canShowFields = this.fieldsIsRequired;

      if (!this.fieldsIsRequired && this.ad.cplModeration) {
        const {
          firstName,
          lastName,
          secondName,
        } = this.ad.cplModeration;
        const cplIsDirt = Boolean(firstName || lastName || secondName);
        if (cplIsDirt) {
          this.showFields();
        } else {
          this.hideFields();
        }
      }
    };

    $rootScope.$on(addressChanged, () => {
      refreshFieldsState();
    });

    $rootScope.$on('user.setUser', () => {
      refreshFieldsState();
    });

    if (!this.ad.cplModeration) {
      this.ad.cplModeration = {
        firstName: '',
        lastName: '',
        secondName: '',
        personType: PersonTypes.NATURAL.value,
      };
    } else if (this.ad.cplModeration.personType !== PersonTypes.NATURAL.value) {
      // Для старых объявлений от юр лица делаем подмену personType
      this.ad.cplModeration = {
        ...this.ad.cplModeration,
        personType: PersonTypes.NATURAL.value,
      };
    }
    this.personTypesItems = Object.values(PersonTypes);
    this.validation = {
      firstName: validation(this.form, 'cplModeration.firstName', {
        required: 'Введите Имя',
        minlength,
        validatorNames,
      }),
      lastName: validation(this.form, 'cplModeration.lastName', {
        required: 'Введите Фамилию',
        minlength,
        validatorNames,
      }),
      secondName: validation(this.form, 'cplModeration.secondName', {
        required: 'Введите Отчество',
        minlength,
        validatorNames,
      }),
      personType: validation(this.form, 'cplModeration.personType', {
        required: 'Выберите тип лица',
      }),
    }

    this.fieldsIsRequired = checkCplFieldsAreEnabled();
    this.canShowFields = this.fieldsIsRequired;
    this.canShowButton = !this.fieldsIsRequired;
    const isPersonOfType = type => this.ad.cplModeration.personType === type.value;
    this.isEntityPerson = () => isPersonOfType(PersonTypes.LEGAL);
    this.isIndividualPerson = () => isPersonOfType(PersonTypes.NATURAL);

    this.showFields = () => {
      this.canShowFields = true;
    }
    this.hideFields = () => {
      if (this.canShowButton) {
        this.canShowFields = false;
      }
    }
    this.cancel = () => {
      this.hideFields();
    }
  }
]
